import BaseFeature from '../../foundation/base/base';

class RecipeNutrition extends BaseFeature {
	constructor(element) {
		super(element);
		this.matchItem = this.matchItem.bind(this);
		this.initDomCache();
		const dropdown = element.querySelector('[data-select]');
		this.nutritionItems = element.querySelectorAll('[data-item]');
		let activeItem = element.querySelector('[data-active]');

		dropdown.addEventListener('change', () => {
			const selectedValue = dropdown.value;
			const correspondingItem = this.matchItem(selectedValue);
			activeItem.removeAttribute('data-active');
			correspondingItem.setAttribute('data-active', true);
			activeItem = element.querySelector('[data-active]');
		});
	}

	matchItem(selectedValue) {
		let match;
		for (let i = 0; i < this.nutritionItems.length; i++) {
			if (selectedValue === this.nutritionItems[i].id) {
				match = this.nutritionItems[i];
			}
		}
		return match;
	}
}

export default RecipeNutrition;
